import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/industrialparks`;

export default {
    getData(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${resource}/byadmin`, {
            baseURL,
            headers,
            params,
        });
    },
    getDataByCityId(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${resource}`, {
            baseURL,
            headers,
            params,
        });
    },
    postData(body, baseURL = {}, headers = {}, params = {}){
        return BaseRepository.post(`${resource}`, body, {
            baseURL,
            headers,
            params,
        });
    },
    getDataById(id, baseURL = {}, headers = {}, params = {}){
        return BaseRepository.get(`${resource}/${id}`, {
            baseURL,
            headers,
            params,
        });
    },
    editData(id,body ,baseURL = {}, headers = {}, params = {}){
        return BaseRepository.put(`${resource}/${id}`,body,{
            baseURL,
            headers,
            params,
        });
    },
    deleteData(id ,baseURL = {}, headers = {}, params = {}){
        return BaseRepository.delete(`${resource}/${id}`,{
            baseURL,
            headers,
            params,
        });
    },
}